var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 11.6501L0.350098 6.0001L6.0001 0.350098L7.0501 1.4001L2.4501 6.0001L7.0501 10.6001L6.0001 11.6501Z",
    fill: "#212129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLar);
export default __webpack_public_path__ + "static/media/lar.1718d6103fbc30e13c1a14822a5c853d.svg";
export { ForwardRef as ReactComponent };